import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';

const API = `${(window.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || '')}/api`;

/** Aviso de pagos mensuales (recordatorio del 18 al 21 y pagos sin marcar pasado el 21). Solo admin lo recibe. */
const PaymentNoticeBanner = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/recurring/notifications`).then((res) => setItems(res.data?.items || [])).catch(() => {});
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="space-y-2" data-testid="payment-banner">
      {items.map((n) => (
        <Link
          key={n.kind}
          to="/pagos-mensuales"
          className={`flex items-start gap-3 rounded-lg border p-3 transition-colors ${
            n.level === 'urgent' ? 'border-red-200 bg-red-50 hover:bg-red-100' : 'border-amber-200 bg-amber-50 hover:bg-amber-100'
          }`}
          data-testid={`payment-banner-${n.kind}`}
        >
          <CalendarClock className={`h-5 w-5 mt-0.5 ${n.level === 'urgent' ? 'text-red-600' : 'text-amber-600'}`} />
          <div>
            <p className={`text-sm font-semibold ${n.level === 'urgent' ? 'text-red-800' : 'text-amber-800'}`}>{n.title}</p>
            <p className={`text-sm ${n.level === 'urgent' ? 'text-red-700' : 'text-amber-700'}`}>{n.message}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default PaymentNoticeBanner;
